import Layout from 'containers/Layout';
import OidcLogin from 'components/OidcLogin';
import React,{useState, useEffect} from 'react';
import { fromPairs } from 'lodash';

export const PrivateRoute = ({ component, modules, onAppOrgChange,...rest }) => {
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
    onAppOrgChange(orgId);
  }
  const { token_type } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};

  if (token_type) return <Layout modules={modules} onlOrgChange={onOrgChange}/>;
  
  return <OidcLogin />;
};
